// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"1f501c46","515":"93d24b3d","597":"feb6e0c9","708":"c71071e1","730":"ea2fa4a4","973":"22f7b0a8"}[chunkId] + ".css";
};